import React, { FC } from 'react';
import { Text as RNText, TextProps } from 'react-native';
// import { textStyles } from './Text.styles';

export const Text: FC<TextProps> = ({ style, ...props }) => (
  <RNText style={[{ color: 'black' }, style]} {...props} />
);
